import { ClosestWithClass } from "../Utilities/HTMLHelpers";

export const ToggleNames = {
    toggleTrigger: "toggle-trigger",//class to denote that this element is a trigger that toggles another element
    findToggleInParent: "toggle-up",//look for parent to toggle
    findToggleInChild: "toggle-down",//look for children to toggle
    toggleSiblings:"toggle-siblings",//look for siblings to toggle off
    toggleable: "toggleable",//class to denote that this element can be toggled
    toggledOn: "toggled-on",//toggled on state
    toggleNumbered: "toggle-numbered",//class to denote that this trigger toggles an index instead of on off
    ToggleIndexAttribute: "data-toggle-number", // the attribute key that stores what index to toggle to, used for tabs
    toggledToIndex: "toggled-to-",//the first part of the string repersenting an indexed toggle, should result in "toggled-to-1" for example


}

export function BindAllToggles(){


    let doms = document.querySelectorAll(".render .toggle-trigger");

    for (let i = 0; i < doms.length; i++) {
        let trigger = doms[i];

        let target:any = trigger;
        if(trigger.classList.contains("toggle-up")){
           target =  ClosestWithClass(trigger,"toggleable");
        }
        else if(trigger.classList.contains("toggle-down")){
            target = trigger.querySelector(".toggleable");
        }

        if(target&&trigger){

        
            if(trigger.classList.contains(ToggleNames.toggleNumbered)){
                
                let number = trigger.getAttribute(ToggleNames.ToggleIndexAttribute);
                if(number){
                    
                    (trigger as any).addEventListener("click",()=>{

                        let classes = target.classList;
                        for(let i = 0;i<classes.length;i++){
                            let cl = classes[i];
                            if(cl.startsWith(ToggleNames.toggledToIndex)){
                                target.classList.remove(cl);
                            }
                        }

                        target.classList.add(ToggleNames.toggledToIndex+number);
                    });


                }


            }
            else
            (trigger as any).addEventListener("click",(e:any)=>{
                if(target.classList.contains(ToggleNames.toggleSiblings)&&!target.classList.contains(ToggleNames.toggledOn)){
                    let parent = target.parentElement;
                    if(parent){
                        let siblings = parent.querySelectorAll(".toggleable");
                        for(let i = 0;i<siblings.length;i++){
                            siblings[i].classList.remove(ToggleNames.toggledOn);
                        }
                    }
                }
                target.classList.toggle("toggled-on");
                target.classList.add("after-toggle");
                setTimeout(()=>{
                    target.classList.remove("after-toggle");
                },350);
            })
        }

    }

}